(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Recall_status', Recall_status);

    Recall_status.$inject = ['$resource'];

    function Recall_status ($resource) {
        var resourceUrl =  'api/recall-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
